import { lazy } from 'react';
import { RouteDefinition } from "./types";

const Login = lazy(() => import('../pages/Auth/Login'));
const Register = lazy(() => import('../pages/Auth/Register'));
const AccountConfirmation = lazy(() => import('../pages/Auth/AccoutConfirmation'));
const ResetPassword = lazy(() => import('../pages/Auth/ResetPassword'));
const ManageToken = lazy(() => import('../pages/Auth/ManageToken'));
const TwoFactorVerify = lazy(() => import('../pages/Auth/TwoFactorVerify'));

export const publicroutes: RouteDefinition[] = [
    {
        component: Login,
        exact: true,
        name: 'login',
        path: '/login',
        access: false
    },
    {
        component: Register,
        exact: true,
        name: 'register',
        path: '/register',
        access: false
    },
    {
        component: AccountConfirmation,
        exact: true,
        name: 'account-confirmation',
        path: '/register/confirmation/:confirmtoken?',
        access: false
    },
    {
        component: ResetPassword,
        exact: true,
        name: 'reset-password',
        path: '/reset-password',
        access: false
    },
    {
        component: ManageToken,
        exact: true,
        name: 'manage-token',
        path: '/manage',
        access: false
    },
    {
        component: TwoFactorVerify,
        exact: true,
        name: '2fa-verify',
        path: '/2fa-verify',
        access: false
    },
];
